import type { AxiosInstance, AxiosResponse } from 'axios';
import { govApiLog } from '@gov-nx/core/app';
import type { PodaniOsvedceniSeznamDto } from '../generated';

export const myVerificationsQuery = async <Params>(
	axiosInstance: AxiosInstance,
	params: Params
): Promise<PodaniOsvedceniSeznamDto> => {
	govApiLog('/api/v1/osvedceni');
	const { data } = await axiosInstance.get('/api/v1/osvedceni', {
		params,
	});
	return data;
};

const searchOnFE = async <Params>(
	axiosInstance: AxiosInstance,
	params: Params,
	search: string,
	start = 0,
	buffer: PodaniOsvedceniSeznamDto = { seznam: [], pocet: 0 }
): Promise<PodaniOsvedceniSeznamDto> => {
	const pocet = 500;
	const result = await myVerificationsQuery(axiosInstance, {
		...params,
		start,
		pocet,
	});

	const filtered =
		result.seznam?.filter(
			(item) =>
				item.nazevUkonu?.toLowerCase().includes(search.toLowerCase()) ||
				item.adresatUkonu?.toLowerCase().includes(search.toLowerCase())
		) ?? [];

	const newBuffer: PodaniOsvedceniSeznamDto = {
		seznam: [...(buffer.seznam ?? []), ...filtered],
		pocet: (buffer.pocet ?? 0) + filtered.length,
	};

	if (start >= (result.pocet ?? 0)) {
		return newBuffer;
	}
	return searchOnFE(axiosInstance, params, search, start + pocet, newBuffer);
};

export const myVerificationsSearchQuery = async <
	Params extends { start?: number; pocet?: number },
>(
	axiosInstance: AxiosInstance,
	search: string,
	params: Params
): Promise<PodaniOsvedceniSeznamDto> => {
	const result = await searchOnFE(axiosInstance, params, search);
	const start = params.start ?? 0;
	const pocet = params.pocet ?? 10;

	return {
		pocet: result.pocet,
		seznam: result.seznam?.slice(start, start + pocet),
	};
};

export const verificationDownloadQuery = async ({
	id,
	axiosInstance,
}: {
	id: string;
	axiosInstance: AxiosInstance;
}): Promise<AxiosResponse<Blob>> =>
	await axiosInstance.get(`/api/v1/osvedceni/${id}/stahnout`, {
		responseType: 'blob',
	});
